import { PluginStore } from "graylog-web-plugin/plugin";
import i18n from "i18n";
import iterateConfirmationHooks from "views/hooks/IterateConfirmationHooks";
const defaultConfirm = async () => (
  // eslint-disable-next-line no-alert
  window.confirm(i18n.t("views_logic.confirm_delete_dashboard_page", { ns: "search" }))
);
const ConfirmDeletingDashboardPage = async (dashboardId, activeQueryId, widgetIds) => {
  const _widgetIds = widgetIds.map((ids) => ids.toArray()).toObject();
  const deletingDashboardPageHooks = PluginStore.exports("views.hooks.confirmDeletingDashboardPage");
  return iterateConfirmationHooks(
    [...deletingDashboardPageHooks, defaultConfirm],
    dashboardId,
    activeQueryId,
    _widgetIds
  );
};
export default ConfirmDeletingDashboardPage;
